import { FC } from "react";

import { KanbanColumnHeaderStyled } from "../rides.kanban.styled";

interface IKanbanColumnHeaderProps {
  title: string;
  gridArea: string;
  itemsCount: number | undefined;
  bottomBorderColor: string;
}

export const KanbanColumnHeader: FC<IKanbanColumnHeaderProps> = ({
  itemsCount,
  gridArea,
  title,
  bottomBorderColor,
}) => {
  return (
    <KanbanColumnHeaderStyled
      data-e2e-id={gridArea}
      $gridArea={gridArea}
      $borderBottomColor={bottomBorderColor}
    >
      <span>{title}</span>
      <label>{itemsCount || 0}</label>
    </KanbanColumnHeaderStyled>
  );
};
